import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { StyleSheet, css } from 'aphrodite';

import { ColorEnvironment, Font, Control } from './Styles';
import Image from './Image';
import ScenarioList from './models/ScenarioList';
import Progress from './models/Progress';

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    margin: 10
  },
  cityName: {
    position: 'absolute',
    bottom: -4,
    left: 16,
    right: 16,
    padding: 4,
    textAlign: 'center',
  },
});

class ScenarioIcon extends Component {
  render() {
    let city = ScenarioList[this.props.cityNumber];
    if (this.props.cityNumber <= Progress.highestCompletedLevel() + 1) {
      return(
        <Link to={`/cities/${city.path}`}>
          <Image extraStyles={[styles.container, Control.heroImage]} filename={city.path + ".png"}>
            <div className={css(Font.heading, ColorEnvironment.inverse, styles.cityName)}>{city.name}</div>
          </Image>
        </Link>
      );
    } else {
      return(
        <Image extraStyles={[styles.container, Control.heroImage]} filename={["locked.png", city.path + ".png"]}>
          <div className={css(Font.heading, ColorEnvironment.inverse, styles.cityName)}>{city.name}</div>
        </Image>
      );
    }
  }
}

export default ScenarioIcon;



// WEBPACK FOOTER //
// ./src/ScenarioIcon.js